
module.exports = {
	status: 'ready',
	title: 'Search input',
	notes: '',
	context: {
	},
};
